import { Badge } from "react-bootstrap";

import { ITableColumns } from "../../../../shared/interfaces/ITable";
import { DehydratedGovPlanSecretaryProject } from "./model/project";
import Masks from "../../../../shared/utils/mask.utils";

export const projectColumns =
    (): ITableColumns<DehydratedGovPlanSecretaryProject>[] => [
        {
            key: "id",
            name: "Código",
            dataKey: "id",
        },
        {
            key: "name",
            dataKey: "name",
            name: "Nome",
        },
        {
            key: "amount",
            dataKey: "amount",
            name: "Montante",
            render: (value) => (value ? Masks.currency(value as number) : ""),
        },
        {
            key: "status",
            dataKey: "status",
            name: "Status",
            render: (_, record) => {
                return (
                    <Badge bg={record.variant} className="capitalize">
                        {record.status}
                    </Badge>
                );
            },
        },
        {
            key: "deadline",
            dataKey: "deadline",
            name: "Data limite",
            render: (value) =>
                value ? Masks.date((value as Date).toISOString()) : "",
        },
        {
            key: "createdAt",
            dataKey: "createdAt",
            name: "Criado em",
            render: (value) =>
                value ? Masks.date((value as Date).toISOString()) : "",
        },
    ];
